export const MODAL_SIZE = {
  LARGE: 'LARGE',
  REGULAR: 'REGULAR',
  FULL_WIDTH: 'FULL_WIDTH',
};
